module.exports = __webpack_public_path__ + "img/aw.89a52a32.svg";